import { motion } from 'framer-motion';
import BSNavbar from '../../component/Navbar/Navbar';

const Reflection = () => {
  const title = '開發者小記';

  return (
    <div style={{ height: '100vh', width: '100%' }}>
      <BSNavbar />
      <motion.h1
        initial={{ opacity: 0 }}
        animate={{ opacity: 1 }}
        transition={{ duration: 1 }}
        style={{ marginLeft: '10%' }}
        className='mt-5'
      >
        {title.split('').map((letter, index) => (
          <motion.span
            key={index}
            initial={{ x: -50, opacity: 0 }}
            animate={{ x: 0, opacity: 1 }}
            transition={{ delay: index * 0.2 }}
          >
            {letter}
          </motion.span>
        ))}
      </motion.h1>
      <motion.p
        initial={{ opacity: 0 }}
        animate={{ opacity: 1 }}
        transition={{ delay: 1.3, duration: 0.7 }}
        style={{ marginLeft: '10%', marginRight: '7%' }}
      >
        —— 112.8.23，浩然圖書館六樓<br /><br />
      </motion.p>
      <motion.p
        initial={{ opacity: 0 }}
        animate={{ opacity: 1 }}
        transition={{ delay: 2.3, duration: 0.7 }}
        style={{ marginLeft: '10%', marginRight: '7%', paddingBottom: '50px' }}
      >
        八月下旬的浩然，熙來攘往。<br /><br />
        兩年前的九月，剛踏進交大的我看著NCTU+的心得選課，沒想到不久後就無法連線，讓NCTU+逐漸淡出交大人的視野。<br /><br />
        兩年後的六月，我非常幸運獲得加入團隊的機會，開始參與開發。歷經兩個多月的努力，我們終於讓NCTU+脫胎換骨，延續往日的風采，陪伴交大的莘莘學子。<br /><br />
        回顧暑假開發的五個案子，NCTU+雖然無償，卻有非凡的意義。兩個月的設計、開發、測試，努力刻畫出心中想像的NCTU+，只期盼能在開學前完成，讓大家選課時能參考學長姐的心得。<br /><br />
        特別感謝團隊的學長鼎力相助，才能如期完工。期待大家踴躍分享心得，照亮交大人選課之路。<br /><br />
        走過兩個寒暑，終於在交大留下微小的足跡，實為至幸。
      </motion.p>
    </div>
  )
}

export default Reflection;